<template>
  <div id="base-product-header">
    <v-container fluid grid-list-xl px-0 v-if="productDetails">
      <v-layout align-center justify-center row wrap>
        <v-flex xs2>
          <v-img
            :aspect-ratio="4 / 4"
            cover
            :lazy-src="require('@/assets/NoPicture.png')"
            :src="
              productDetails.mainpictureurl
                ? productDetails.mainpictureurl
                : require('@/assets/NoPicture.png')
            "
          >
            <template v-slot:placeholder>
              <v-layout align-center fill-height justify-center ma-0>
                <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-flex>
        <v-flex pl-0 xs4>
          <div class="body-2 font-weight-bold" style="line-height:1em">
            {{ productDetails.productname }}
          </div>
          <div class="spacing text-uppercase grey--text" style="font-size:6px">
            {{ productDetails.productnameeng }}
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'base-product-header',
  data() {
    return {}
  },
  computed: {
    productId() {
      return window.atob(this.$route.params.productId)
    },
    productDetails() {
      return this.$store.getters['Product/getProductDetails'].map(item => ({
        productname: item.productname,
        mainpictureurl: item.mainpictureurl,
        productnameeng: item.productnameeng
      }))[0]
    }
  },
  created() {
    if (this.$store.state.Product.productDetails)
      this.$store.dispatch('Product/fetchProductDetails', this.productId)
    if (this.$store.state.Product.productImages)
      this.$store.dispatch('Product/fetchProductImages', this.productId)
  }
}
</script>

<style lang="scss" scoped></style>
